import {
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Popover,
  Overlay,
} from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState } from "react";
import { BadgeFitprenda, InputSearch, PushButtonFilter } from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { E_BodyArea, E_GenderType } from "../types";
import ButtomAction from "./ButtonAction";
import "./ProductGrid.css";
import { FormattedMessage, useIntl } from "react-intl";
import ConfirmationModal from "./ConfirmationModal";

const DataTableProducts = (props: any) => {
  let isHandlerActionRaised: boolean = false;
  const { products } = props;

  const [selection, setSelection] = useState([]);
  // const [isHandlerActionRaised, setIsHandlerActionRaised] = useState(false);

  const [filters, setFilters] = useState<any>({
    global: { value: null, matchMode: "contains" },
  });

  const intl = useIntl();

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [targetDataProduct, setTargetDataProduct] = useState<number>(0);

  const [isFilterTop, setIsFilterTop] = useState(false);
  const [isFilterBottom, setIsFilterBottom] = useState(false);

  const [isFilterFemale, setIsFilterFemale] = useState(false);
  const [isFilterMale, setIsFilterMale] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  // useEffect(() => {
  //   initGlobalFilters();
  // }, []);

  // const initGlobalFilters = () => {
  //   setFilters({
  //     global: { value: null, matchMode: "contains" },
  //   });

  //   // {value: null, matchMode: 'contains'}
  // };

  const onClickEdit = (rowData: any) => {
    try {
      if (props.handlerEdit) props.handlerEdit(rowData);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickClone = (rowData: any) => {
    try {
      if (props.handlerClone) props.handlerClone(rowData);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDelete = (rowData: any) => {
    try {
      setShowModal(true); // Show the modal
      if (props.handlerDelete) props.handlerDelete(rowData);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDeleteGroup = (data: any) => {
    try {
      if (props.handlerDeleteGroup) props.handlerDeleteGroup(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickAddSizeGuideGroup = (data: any) => {
    try {
      if (props.handlerAddSizeGuideGroup) props.handlerAddSizeGuideGroup(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDownload = (data: any) => {
    try {
      if (props.handlerDownload) props.handlerDownload(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectionChange = (row: any) => {
    // console.log('ProductGrid onSelectionChange', row);
    // console.log('ProductGrid onSelectionChange Handler', isHandlerActionRaised);

    if (!isHandlerActionRaised) {
      setSelection(row.value);

      if (props.handlerSelectionRow) props.handlerSelectionRow(row.value);
    }

    isHandlerActionRaised = false;
  };

  const onSearch = (value: any) => {
    let _filters = { ...filters };
    _filters["global"].value = value;

    console.log("_Filters", _filters);
    console.log("Valor", value);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchSuperior = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterTop)
      value = intl.formatMessage({
        id: "ready-size-superior",
        defaultMessage: "Superior",
      });

    _filters["global"].value = value;

    setIsFilterBottom(false);
    setIsFilterTop(!isFilterTop);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchInferior = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterBottom) {
      // Use intl.formatMessage for "Inferior"
      value = intl.formatMessage({
        id: "ready-size-inferior",
        defaultMessage: "Inferior",
      });
    }

    _filters["global"].value = value;

    setIsFilterTop(false);
    setIsFilterBottom(!isFilterBottom);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchFemenino = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterFemale) {
      // Use intl.formatMessage for "Femenino"
      value = intl.formatMessage({
        id: "ready-size-female",
        defaultMessage: "Femenino",
      });
    }

    _filters["global"].value = value;

    setIsFilterMale(false);
    setIsFilterFemale(!isFilterFemale);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchMasculino = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterMale) {
      // Use intl.formatMessage for "Masculino"
      value = intl.formatMessage({
        id: "ready-size-male",
        defaultMessage: "Masculino",
      });
    }

    _filters["global"].value = value;

    setIsFilterFemale(false);
    setIsFilterMale(!isFilterMale);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    var qSuperior: number = 0;
    var qInferior: number = 0;
    var qFemenino: number = 0;
    var qMasculino: number = 0;

    if (props.products && props.products.length > 0 && !props.isLoading) {
      qSuperior =
        props.products.filter((element: any) => {
          return (element.BodyArea?.Id || 0) === E_BodyArea.TOP;
        }).length || 0;
      qInferior =
        props.products.filter((element: any) => {
          return (element.BodyArea?.Id || 0) === E_BodyArea.BOTTOM;
        }).length || 0;
      qFemenino =
        props.products.filter((element: any) => {
          return (element.Gender?.Id || 0) === E_GenderType.FEMALE;
        }).length || 0;
      qMasculino =
        props.products.filter((element: any) => {
          return (element.Gender?.Id || 0) === E_GenderType.MALE;
        }).length || 0;
    }

    return (
      <>
        <Row className="justify-content-center">
          <div className="productgrid-main-container">
            <div className="productgrid-table-nav-container">
              <Col
                xs={props.showTitle ? 3 : 0}
                className="text-left productgrid-table-title"
              >
                {props.showTitle ? (
                  <p className="font-fitprenda-section-title">
                    <FormattedMessage
                      id="product-grid-header"
                      // defaultMessage="Tus productos cargados"
                    />{" "}
                    <BadgeFitprenda
                      value={props.products?.length || 0}
                      variant={"success"}
                    />
                  </p>
                ) : (
                  <></>
                )}
              </Col>
              {/* {
            (props.handlerDownload) ?
              <Col xs={1} className="text-end">
                <OverlayTrigger
                  key={`product-grid-export`}
                  placement={'top'}
                  overlay={
                    <Tooltip>
                      Exportar
                    </Tooltip>
                  }>
                  <Button type="button" variant="outline-success" size="sm" onClick={() => onClickDownload(selection)}>
                    <FontAwesomeIcon icon={faFileExcel} />
                  </Button>
                </OverlayTrigger>
              </Col>
              : <></>
          } */}
              <div className="product-grid-buttons-container">
                {qSuperior && qInferior ? (
                  <Col className="product-grid-filter-button">
                    <PushButtonFilter
                      title={
                        <FormattedMessage
                          id="ready-size-superior"
                          defaultMessage="Superior"
                        />
                      }
                      quantity={qSuperior}
                      StateFilter={isFilterTop}
                      ClickSuscribe={onSearchSuperior}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qSuperior && qInferior ? (
                  <Col className="product-grid-filter-button">
                    <PushButtonFilter
                      title={
                        <FormattedMessage
                          id="ready-size-inferior"
                          defaultMessage="Inferior"
                        />
                      }
                      quantity={qInferior}
                      StateFilter={isFilterBottom}
                      ClickSuscribe={onSearchInferior}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qFemenino && qMasculino ? (
                  <Col className="product-grid-filter-button">
                    <PushButtonFilter
                      title={
                        <FormattedMessage
                          id="ready-size-female"
                          defaultMessage="Femenino"
                        />
                      }
                      quantity={qFemenino}
                      StateFilter={isFilterFemale}
                      ClickSuscribe={onSearchFemenino}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qFemenino && qMasculino ? (
                  <Col className="product-grid-filter-button">
                    <PushButtonFilter
                      title={
                        <FormattedMessage
                          id="ready-size-male"
                          defaultMessage="Masculino"
                        />
                      }
                      quantity={qMasculino}
                      StateFilter={isFilterMale}
                      ClickSuscribe={onSearchMasculino}
                    />
                  </Col>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="productgrid-search-excel-container">
              <InputSearch
                className="productgrid-searchbar"
                onInputChange={onSearch}
              />
              {props.handlerDownload ? (
                // <Col xs={1} className="text-end">
                <OverlayTrigger
                  key={`product-grid-export`}
                  placement={"top"}
                  overlay={
                    <Tooltip>
                      <FormattedMessage
                        id="edit-tooltip"
                        defaultMessage="Editar"
                      />
                    </Tooltip>
                  }
                >
                  <Button
                    type="button"
                    variant="outline-success"
                    className=" product-grid-excel-button"
                    size="sm"
                    onClick={() => onClickDownload(selection)}
                  >
                    <FontAwesomeIcon icon={faFileExcel} />
                  </Button>
                </OverlayTrigger>
              ) : (
                // </Col>
                <></>
              )}
            </div>
          </div>
          <div className="product-grid-buttons-delete-container">
            {selection && selection.length > 1 && props.handlerDeleteGroup ? (
              <div className="product-grid-delete-container">
                <ButtomAction
                  label={`Borrar`}
                  eventClick={() => onClickDeleteGroup(selection)}
                ></ButtomAction>
              </div>
            ) : (
              <></>
            )}
            {selection &&
            selection.length > 1 &&
            props.handlerAddSizeGuideGroup ? (
              <div className="product-grid-associate-container">
                <ButtomAction
                  label={`Asociar Guía`}
                  eventClick={() => onClickAddSizeGuideGroup(selection)}
                ></ButtomAction>
              </div>
            ) : (
              <></>
            )}
          </div>
        </Row>
      </>
    );
  };

  const renderSize = (rowData: any) => {
    try {
      if (rowData && rowData.Sizes) {
        return rowData.Sizes.map((element: any) => element.Name).join(", ");
      } else {
        return "";
      }
    } catch (error) {}
  };

  const renderCategories = (rowData: any) => {
    try {
      /*          console.log('renderCategories', rowData);*/

      //if (rowData && rowData.PlatformCategory) {
      //    return rowData.PlatformCategory.map(
      //        (element: any) => element.Name
      //    ).join(", ");
      //} else {
      //    return "";
      //}

      if (rowData && rowData.ProductType) {
        return rowData.ProductType.Name;
      } else {
        return "";
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderVariants = (rowData: any) => {
    try {
      if (rowData && rowData.VariantsId) {
        const variants: string = rowData.VariantsId.join(", ");

        return variants.length > 20
          ? variants.substring(0, 20).trim() + "..."
          : variants.trim();
      } else {
        return "";
      }
    } catch (error) {}
  };

  const renderRowEdit = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center`}>
            <OverlayTrigger
              key={`edit-${rowData.Id}`}
              placement={"top"}
              overlay={<Tooltip>Editar</Tooltip>}
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => onClickEdit(rowData)}
              >
                <FontAwesomeIcon icon={"pen"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);

      return <></>;
    }
  };

  const renderRowDuplicate = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center`}>
            <OverlayTrigger
              key={`clone-${rowData.Id}`}
              placement={"top"}
              overlay={<Tooltip>Duplicar</Tooltip>}
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => onClickClone(rowData)}
              >
                <FontAwesomeIcon icon={"clone"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);

      return <></>;
    }
  };

  const renderRowDelete = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center`}>
            <OverlayTrigger
              key={`remove-${rowData.Id}`}
              placement={"top"}
              overlay={<Tooltip>Borrar</Tooltip>}
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => {
                  setShowModal(true);
                  setSelectedRowData(rowData);
                }}
              >
                <FontAwesomeIcon icon={"trash-alt"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);
      return <></>;
    }
  };

  const renderActionRow = (event: any) => {
    // console.log('renderActionRow', event);

    return (
      <>
        <div className="text-start" onClick={(e: any) => handleClick(e)}>
          <FontAwesomeIcon icon={"ellipsis-v"} />
          <Overlay
            show={show}
            target={target}
            placement={"left"}
            containerPadding={20}
          >
            <Popover>
              <Popover.Body>
                {props.handlerEdit ? (
                  <>
                    <Row className="action-button">
                      <Col xs={1}>
                        <FontAwesomeIcon icon={"pen"} />
                      </Col>
                      <Col>
                        <span
                          data-product={event.Id}
                          onClick={(e: any) => onClickEdit(e)}
                        >
                          Editar
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
                {props.handlerClone ? (
                  <>
                    <hr className="nav-side-divider" />
                    <Row className="action-button">
                      <Col xs={1}>
                        <FontAwesomeIcon icon={"clone"} />
                      </Col>
                      <Col>
                        <span
                          data-product={event.Id}
                          onClick={() => props.handlerClone(event)}
                        >
                          Duplicar
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
                {props.handlerDelete ? (
                  <>
                    <hr className="nav-side-divider" />
                    <Row className="action-button">
                      <Col xs={1}>
                        <FontAwesomeIcon icon={"trash-alt"} />
                      </Col>
                      <Col>
                        <span
                          data-product={event.Id}
                          onClick={() => props.handlerDelete(event)}
                        >
                          Eliminar
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </Popover.Body>
            </Popover>
          </Overlay>
        </div>
      </>
    );
  };

  const handleClick = (event: any) => {
    // console.log('Menu handleClick', {event: event, handlerAction: isHandlerActionRaised });

    try {
      setShow(!show);

      if (!show && !isHandlerActionRaised) {
        console.log("Menu handleClick SetTarget", event);
        console.log(
          "Menu handleClick SetTarget",
          event.target.parentElement.parentElement
        );
        // console.log('Menu handleClick SetTarget P0', event.target.parentElement.attributes['data-product'].nodeValue);
        // console.log('Menu handleClick SetTarget P1', event.target.parentElement.parentElement.attributes['data-product'].nodeValue);

        if (event.target.parentElement.attributes["data-product"])
          console.log(
            "Menu handleClick SetTarget P0",
            event.target.parentElement.attributes["data-product"].nodeValue
          );
        if (event.target.parentElement.parentElement.attributes["data-product"])
          console.log(
            "Menu handleClick SetTarget P0",
            event.target.parentElement.parentElement.attributes["data-product"]
              .nodeValue
          );

        setTarget(event.target.parentElement.parentElement);

        if (event.target.parentElement.attributes["data-product"])
          setTargetDataProduct(
            parseInt(
              event.target.parentElement.attributes["data-product"].nodeValue ||
                "0"
            )
          );
        if (event.target.parentElement.parentElement.attributes["data-product"])
          setTargetDataProduct(
            parseInt(
              event.target.parentElement.parentElement.attributes[
                "data-product"
              ].nodeValue || "0"
            )
          );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container product-grid-container">
      <div className="row">
        <div className="col-lg-12">
          <div className="table-fitprenda-content">
            <DataTable
              value={products}
              dataKey="Id"
              header={renderHeader()}
              responsiveLayout="scroll"
              scrollable
              scrollHeight={props.scrollHeight || "230px"}
              selectionMode="checkbox"
              selection={selection}
              onSelectionChange={(e) => onSelectionChange(e)}
              size="small"
              filters={filters}
              globalFilterFields={[
                "Code",
                "Description",
                "BodyArea.Name",
                "Gender.Name",
                "FitType.Name",
                "SizeGuide.Name",
              ]}
              loading={props.isLoading || false}
            >
              {props.handlerSelectionRow ? (
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "2em" }}
                  style={{ maxWidth: "34px" }}
                ></Column>
              ) : null}
              <Column
                field="Code"
                header={
                  <FormattedMessage
                    id="ready-size-model"
                    defaultMessage="Modelo"
                  />
                }
                sortable
                style={{ minWidth: "100px" }}
                className="product-grid-modelo"
              ></Column>
              <Column
                header={
                  <FormattedMessage
                    id="product-grid-sku"
                    defaultMessage="SKU"
                  />
                }
                body={renderVariants}
                // bodyClassName={"text-nowrap"}
                style={{ minWidth: "130px" }}
                className="product-grid-sku"
              ></Column>
              <Column
                field="Description"
                header={
                  <FormattedMessage
                    id="ready-size-description"
                    defaultMessage="Descripción"
                  />
                }
                sortable
                style={{ minWidth: "130px" }}
                className="product-grid-descripcion"
              ></Column>
              <Column
                field="BodyArea.Name"
                header={
                  <FormattedMessage
                    id="ready-size-position"
                    defaultMessage="Posición"
                  />
                }
                sortable
                style={{ minWidth: "100px" }}
                className="product-grid-bodyarea"
              ></Column>
              <Column
                field="Gender.Name"
                header={
                  <FormattedMessage
                    id="ready-size-gender"
                    defaultMessage="Género"
                  />
                }
                sortable
                style={{ minWidth: "100px" }}
                className="product-grid-gender"
              ></Column>
              <Column
                field="FitType.Name"
                header={
                  <FormattedMessage id="ready-size-fit" defaultMessage="Fit" />
                }
                sortable
                style={{ minWidth: "60px" }}
                className="product-grid-fit"
              ></Column>
              <Column
                header={
                  <FormattedMessage
                    id="ready-size-sizes"
                    defaultMessage="Talles"
                  />
                }
                body={renderSize}
                style={{ minWidth: "70px" }}
                className="product-grid-talle"
              ></Column>
              <Column
                header={
                  <FormattedMessage
                    id="product-grid-category"
                    defaultMessage="Categoria"
                  />
                }
                body={renderCategories}
                style={{ minWidth: "100px" }}
                className="product-grid-categoria"
              ></Column>
              <Column
                field="SizeGuide.Name"
                header={
                  <FormattedMessage
                    id="ready-size-guide"
                    defaultMessage="Guía"
                  />
                }
                sortable
                style={{ minWidth: "100px" }}
                className="product-grid-name"
              ></Column>
              {/* ESTE ES EL EDITAR */}
              {props.handlerEdit ? (
                <Column
                  header=""
                  body={(rowData, event) => renderRowEdit(rowData, event)}
                  bodyClassName={`${
                    !props.handlerClone && !props.handlerDelete ? "me-3" : ""
                  }`}
                  style={{ maxWidth: "35px", minWidth: "20px" }}
                ></Column>
              ) : null}
              {/* ESTE ES CLONE? */}
              {props.handlerClone ? (
                <Column
                  header=""
                  body={(rowData, event) => renderRowDuplicate(rowData, event)}
                  bodyClassName={!props.handlerDelete ? "me-3" : ""}
                  style={{ maxWidth: "35px", minWidth: "20px" }}
                ></Column>
              ) : null}
              {/* ESTE ES EL DELETE */}
              {props.handlerDelete ? (
                <Column
                  header=""
                  body={(rowData, event) => renderRowDelete(rowData, event)}
                  bodyClassName={`me-3`}
                  style={{ maxWidth: "35px", minWidth: "20px" }}
                ></Column>
              ) : null}
              {/* {props.handlerEdit ||
              props.handlerClone ||
              props.handlerDelete ? (
                <Column
                  header=""
                  body={renderActionRow}
                  style={{ maxWidth: "35px", minWidth: "15px" }}
                ></Column>
              ) : null} */}
            </DataTable>
            <ConfirmationModal
              show={showModal}
              onHide={() => {
                setShowModal(false);
                setSelectedRowData(null);
              }}
              deleteFunction={props.handlerDelete}
              rowData={selectedRowData}
              setShowModal={setShowModal}
              setSelectedRowData={setSelectedRowData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTableProducts;
